<template>
  <div>
    <div class="d-flex flex-column px-3 py-1">
      
      <div class="d-flex flex-row flex-wrap justify-content-start text-center" >
        
        <div
          class="d-flex justify-content-center w-100"
          style="margin-top: 110px"
          v-if="loadingTableItinerarySearch"
        >
          <loading />
        </div>
        <data-table
          v-else
          numerador
          :headers="headers"
          :data="dataTableAux"
          :acciones="acciones"
          :max="10"
          buscar
          paginacion
          idtabla="listado_busqueda_itinerarios"
          :seleccionar="obtenerFilaSeleccionada"
        />
          
      </div>
    </div>
    <ver-detalles-itinerario-modal :data="verDetallesItineario" />
    <nueva-reserva-form-component title="Nueva Reserva Desde Itinerario" />
    
  </div>
</template>

<script>
// Vue
import Vue from "vue";

// Vuex
import { mapState, mapActions } from "vuex";

// Componentes
import DataTable from "../../../components/common/DataTable";
import Loading from "../../common/loading";
import VerDetallesItinerarioModal from "../../modals/lineas/itinerarios/VerDetallesItinerarioModal";
import nuevaReservaFormComponent from "../../common/forms/nuevaReservaFormComponent.vue";
// Toast
import VueToastify from "vue-toastify";

Vue.use(VueToastify);


export default {
  props: ["data"],
  data() {
    return {
  
      headers: [
        "Semana",
        "Naviera",
        "Nave",
        "N° Viaje",
        "Servicio",
        "Puerto Embarque",
        "ETD",
        "Puerto Destino",
        "ETA",
        "TT",
        "Acciones",
      ],
      acciones: [],
      verDetallesItineario: [],
      reservarItinerario: [],
      dataTableAux: this.data,
      estadoItinerariosFiltros: false,
      id: "",
    };
  },
  components: {
    DataTable,
    Loading,
    VerDetallesItinerarioModal,
    nuevaReservaFormComponent
  },
  computed: {
    ...mapState([
      "loading",
      "loadingTable",
      "AccionCambiarUsuarioActual",
      "usuarioActual",
      "isAdmin",
    ]),
    ...mapState("lineas", [
      "dataDatatableListarBusquedaItinerariosFiltrada",
      "estadoListarItinerarios",
      'dataPuertoDescarga',
      "loadingTableItinerarySearch"
    ]),
  },
  methods: {
    ...mapActions(["ActionSetLoadingTable"]),
    ...mapActions("lineas", [
      "actionSetVisibleModalDetallesItinerario",
      "actionSetVisibleModalReservaBooking",
      'actionSetDataNaveSeleccionada',
      'actionSetDataFormAgregarReservaFromItinerary'
    ]),

    async generarBotonesAcciones() {
      let me = this;
      me.acciones = [];

      me.data &&
        (await me.dataTableAux.map((index) => {
          // Los itinerarios en BLANK SAILING no son reservables ni tienen detalle
          if (index && index.blank_sailing) {
            me.acciones.push([]);
            return;
          }

          me.acciones.push([
            {
              icon: "fa fa-search zoom",
              title: "Detalle Itinerario",
              id: index,
            },
            {
              icon: "fa fa-paper-plane zoom",
              title: "Reservar Ahora",
              id: index,
            },
          ]);
        }));
      me.ActionSetLoadingTable(false);
      
    },

    obtenerFilaSeleccionada(fila) {
      //

      if (fila.accion == "Detalle Itinerario") {

        this.verDetallesItineario = fila.id;
        this.actionSetVisibleModalDetallesItinerario(true);

      } else if (fila.accion == "Reservar Ahora") {
        
        this.reservarItinerario = fila.id;
        this.actionSetVisibleModalReservaBooking(true);

        const { data, data_complementaria } = fila.id  ;
        this.actionSetDataNaveSeleccionada({
          naviera: {
            id : data_complementaria.naviera_id,
            name : data[1]
          },
          nave: data[2],
          viaje: data[3],
          pol: data_complementaria.chargin_port,
          from_date: data_complementaria.stacking_from,
          to_date: data_complementaria.stacking_to,
          itinerary_id: data_complementaria.itinerary_id,
        });
        
        const user = JSON.parse( localStorage.getItem("user") );

        const client = user.id_role != 3 ? {
          id: user.id_cliente === null ? "" : user.id_cliente.toString(),
          name: user.client
        } : user.client ;

        this.actionSetDataFormAgregarReservaFromItinerary({
          anio : {
            id: data_complementaria.anio.toString(),
            name : data_complementaria.anio.toString()
          } ,
          semana : {
            id: data[0].toString(),
            name: data[0].toString()
          },
          port_of_discharge : {
            id : data_complementaria.pod_id.toString() ,
            name : data[7].toString()
          },
          client,
          clientId: user.id_cliente 
        }) ;


      }
    },
  },
  created() {
    setTimeout(() => {
      this.generarBotonesAcciones();
    }, 400);
  },
  watch: {
    data: function (_new) {
      let me = this;
      if (_new) {
        me.dataTableAux = _new;
        this.generarBotonesAcciones();
      }
    },
  },
};
</script>

<style></style>
